import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unchecked",
  "use": "icon-unchecked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-unchecked\"><defs><clipPath id=\"icon-unchecked_a\"><rect width=\"24\" height=\"24\" rx=\"0\" /></clipPath></defs><g style=\"mix-blend-mode:passthrough\" clip-path=\"url(#icon-unchecked_a)\"><rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"2\" fill=\"#FFF\" /><rect x=\"5.438\" y=\"5.438\" width=\"13.125\" height=\"13.125\" rx=\"1.563\" fill-opacity=\"0\" stroke=\"#276BEC\" stroke-width=\".875\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol